<template>
	<div v-title title="评价" class="pj-page">
		<div class="box goods-box">
			<img class="img" :src="detail.orderItemList[0].productPic" alt="">
			<div class="title">{{ detail.orderItemList[0].productName }}</div>
			<div class="grey">{{ detail.orderItemList[0].productAttrStr }}</div>
		</div>
		<div class="box pj-box">
			<div class="line-1">
				<div class="pj-img-box" @click="pingjiaForm.star = 5">
					<img class="icon" v-if="pingjiaForm.star != 5" src="@/assets/images/order/icon_pj_1.png" alt="">
					<img class="icon" v-if="pingjiaForm.star == 5" src="@/assets/images/order/icon_pj_1_s.png" alt="">
					<span :class="pingjiaForm.star == 5 ? 'text green' : 'text'">好评</span>
				</div>
				<div class="pj-img-box" @click="pingjiaForm.star = 3">
					<img class="icon" v-if="pingjiaForm.star != 3" src="@/assets/images/order/icon_pj_2.png" alt="">
					<img class="icon" v-if="pingjiaForm.star == 3" src="@/assets/images/order/icon_pj_2_s.png" alt="">
					<span :class="pingjiaForm.star == 3 ? 'text green' : 'text'">中评</span>
				</div>
				<div class="pj-img-box" @click="pingjiaForm.star = 0">
					<img class="icon" v-if="pingjiaForm.star != 0" src="@/assets/images/order/icon_pj_3.png" alt="">
					<img class="icon" v-if="pingjiaForm.star == 0" src="@/assets/images/order/icon_pj_3_s.png" alt="">
					<span :class="pingjiaForm.star == 0 ? 'text green' : 'text'">差评</span>
				</div>
			</div>
			<div class="line-2">
				<div class="fl-item fl-item-s">
					材质质感
				</div>
				<div class="fl-item fl-item-s">
					使用感受
				</div>
				<div class="fl-item fl-item-s">
					商品品质
				</div>
			</div>
			<van-field class="input-text" v-model="pingjiaForm.content" rows="6" autosize show-word-limit type="textarea"
				maxlength="250" placeholder="展开说说对商品的想法吧..." />
		</div>

		<div class="mine-btn" @click="submit">提交</div>
		<MyDialog :dialogForm="dialogForm" />

		<div ref="maidian" td-event="2668024000,https://cloudmall.counton.com.cn/commbank-ip/#/pingjia"></div>
	</div>
</template>

<script>
import { post } from 'api/post'
import MyDialog from '@/components/MyDialog.vue'
export default {
	name: "Order",
	components: {
		MyDialog,
	},
	data() {
		return {
			dialogForm: {
				show: false,
				title: '',
				contentText: '',
				contentTips: '',
				// btnCancelText: '取 消',
				btnConfirmText: '',
				cancelCallback: () => {
					this.dialogForm.show = false
				},
				confirmCallback: () => {
					this.dialogForm.show = false
				}
			},
			radio: '1',
			message: '',
			pingjiaForm: {
				star: 5,
				content: '',
				orderId: '',
				productId: '',
				productName: '',
				productAttr: '',
			},
			detail: {
				orderItemList: [
					{}
				]
			}
		};
	},
	created() {
		this.pingjiaForm.orderId = this.$route.query.orderId
		this.pingjiaForm.productId = this.$route.query.productId
		this.pingjiaForm.productName = this.$route.query.productName
		this.pingjiaForm.productAttr = this.$route.query.productAttr

		this.getDetail()

		let self = this
		this.$nextTick(() => {
			self.$refs['maidian'].click()
		})
	},
	methods: {
		getDetail() {
			this.$get('order/detail/' + this.pingjiaForm.orderId, {}).then((res) => {
				console.log(res)
				if (res.code === this.GLOBAL.SUCCESS) {
					this.detail = res.data
					this.detail.orderItemList.forEach(item => {
						let arr = JSON.parse(item.productAttr)
						console.log(arr)
						let str = ''
						arr.forEach(item2 => {
							str += item2.key + ':' + item2.value + ';'
						})
						item.productAttrStr = str
					})


				} else {
					this.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#ee0a24'
					})
				}
			})
		},
		submit() {
			let self = this
			self.dialogForm = {
				show: true,
				title: '提示',
				contentText: '是否提交评论？',
				contentTips: '',
				btnCancelText: '暂不提交',
				btnConfirmText: '确认',
				cancelCallback: () => {
					this.dialogForm.show = false
				},
				confirmCallback: () => {
					this.dialogForm.show = false
					post('productcomment/add', this.pingjiaForm).then((res) => {
						console.log(res)
						if (res.code === this.GLOBAL.SUCCESS) {
							self.$toast('提交成功');
							this.$router.push({
								path: '/orderList',
								query: {
									status: '8',
								}
							})
						} else {
							this.$dialog.alert({
								theme: 'round-button',
								message: res.message,
								confirmButtonColor: '#ee0a24'
							})
						}
					})
				}
			}
		},
		onClickLeft() {
			this.$router.push({
				path: '/orderList',
				query: {
					status: '8',
				}
			})
		}
	},
}
</script>

<style scoped lang="less">
.pj-page {
	box-sizing: border-box;
	width: 375px;
	height: 100vh;
	background: #F7F7F7;
	padding: 10px;

	.box {
		box-sizing: border-box;
		width: 355px;
		min-height: 94px;
		background: #FFFFFF;
		border-radius: 10px;
	}

	.goods-box {

		padding: 12px;
		position: relative;

		.img {
			width: 70px;
			height: 70px;
			border-radius: 6px;
			position: absolute;
			top: 12px;
			left: 12px;
		}

		.title {
			position: absolute;
			top: 14px;
			left: 94px;
			width: 247px;
			height: 36px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 13px;
			color: #333333;
			line-height: 18px;
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 2;
			overflow: hidden;
		}

		.grey {
			position: absolute;
			top: 54px;
			left: 94px;
			width: 242px;
			height: 14px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 11px;
			color: #999999;
			line-height: 14px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
	}

	.pj-box {
		margin: 10px auto 0;
		padding: 12px;
		position: relative;

		.line-1 {
			display: flex;
			align-items: flex-start;

			.pj-img-box {
				display: flex;
				flex-direction: row;
				flex-wrap: nowrap;
				align-content: center;
				justify-content: center;
				align-items: center;
				margin-right: 25px;

				.icon {
					width: 24px;
					height: 24px;
					margin-right: 6px;
				}

				.text {
					width: 26px;
					height: 16px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 13px;
					color: #CCCCCC;
					line-height: 16px;
					text-align: left;
					font-style: normal;
				}

				.green {
					color: #00754A;
				}
			}
		}

		.line-2 {
			margin: 16px 0;
			display: flex;
			flex-direction: row;
			flex-wrap: nowrap;
			align-content: center;
			justify-content: flex-start;
			align-items: center;

			.fl-item {
				margin-right: 10px;
				box-sizing: border-box;
				width: 68px;
				height: 30px;
				border-radius: 8px;
				border: 0.5px dashed #CCCCCC;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 12px;
				color: #333333;
				line-height: 30px;
				text-align: center;
			}

			.fl-item-s {
				background: rgba(0, 117, 74, 0.06);
				border-radius: 8px;
				color: #00754A;
				border: none;
			}
		}

		.input-text {
			// background-color: #ff9d9d76;
		}
	}

	.mine-btn {
		position: fixed;
		bottom: 15px;
		left: 10px;
		width: 355px;
		height: 40px;
		background: #00754a;
		border-radius: 10px;
		font-size: 15px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 500;
		color: #ffffff;
		line-height: 40px;
		text-align: center;
	}
}
</style>



// WEBPACK FOOTER //
// src/view/order/pingjia.vue